// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mfe-beh-smart-groups-settings-start-date {
  width: 140px;
  margin-inline-end: var(--neon-2_15_0-spacing-small);
}

.mfe-beh-smart-groups-settings-roster-date {
  width: 288px;
  margin-inline-end: var(--neon-2_15_0-spacing-small);
}

.mfe-beh-smart-groups-settings-end-date {
  width: 140px;
}

.mfe-beh-smart-groups-settings-filters {
  margin-inline-end: 34px;
}

.mfe-beh-smart-groups-settings-grades {
  width: 288px;
}

.mfe-beh-smart-groups-settings-grades-fixed {
  margin-block-start: var(--neon-2_15_0-spacing-x-large);
}

.mfe-beh-smart-groups-settings-students-added {
  margin-block-start: var(--neon-2_15_0-spacing-x-large);
  display: flex;
  width: 288px;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--neon-2_15_0-spacing-x-small);
}

.mfe-beh-smart-groups-settings-students-added-label {
  color: var(--neon-2_15_0-color-gray-800);
  font: var(--neon-2_15_0-font-2);
  margin: 2px var(--neon-2_15_0-spacing-0);
}

.mfe-beh-smart-groups-settings-students-added-subtext {
  color: var(--neon-2_15_0-text-color-light);
  font: var(--neon-2_15_0-font-1);
  margin: var(--neon-2_15_0-spacing-0);
}

.mfe-beh-smart-groups-settings_continious_date {
  display: flex;
  flex-direction: row;
}

.mfe-beh-smart-groups-settings_continious_date_child {
  display: flex;
  flex-direction: column;
}

.mfe-beh-smart-groups-settings-date-error {
  box-sizing: border-box;
  color: #e21707;
  font: 400 14px/20px Roboto, Arial, Helvetica, sans-serif;
  margin: 2px 0 0;
  padding: 0;
  text-wrap: pretty;
}`, "",{"version":3,"sources":["webpack://./components/smart-groups/smart-group-table/settings/settings.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,mDAAA;AACJ;;AAEA;EACI,YAAA;EACA,mDAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,sDAAA;AACJ;;AAEA;EACI,sDAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;AACJ;;AAEA;EACI,wCAAA;EACA,+BAAA;EACA,wCAAA;AACJ;;AACA;EACI,0CAAA;EACA,+BAAA;EACA,oCAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;AAEJ;;AAAA;EACI,aAAA;EACA,sBAAA;AAGJ;;AADA;EACI,sBAAA;EACA,cAAA;EACA,wDAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;AAIJ","sourcesContent":[".__mfe__settings-start-date {\r\n    width: 140px;\r\n    margin-inline-end: var(--__neon__spacing-small);\r\n}\r\n\r\n.__mfe__settings-roster-date{\r\n    width: 288px;\r\n    margin-inline-end: var(--__neon__spacing-small);;\r\n}\r\n\r\n.__mfe__settings-end-date {\r\n    width: 140px;\r\n}\r\n\r\n.__mfe__settings-filters{\r\n    margin-inline-end: 34px;\r\n}\r\n\r\n.__mfe__settings-grades{\r\n    width: 288px;\r\n}\r\n\r\n.__mfe__settings-grades-fixed{\r\n    margin-block-start: var(--__neon__spacing-x-large);\r\n}\r\n\r\n.__mfe__settings-students-added{\r\n    margin-block-start: var(--__neon__spacing-x-large);\r\n    display: flex;\r\n    width: 288px;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: var(--__neon__spacing-x-small);\r\n}\r\n\r\n.__mfe__settings-students-added-label{\r\n    color: var(--__neon__color-gray-800);\r\n    font: var(--__neon__font-2);\r\n    margin: 2px var(--__neon__spacing-0);\r\n}\r\n.__mfe__settings-students-added-subtext{\r\n    color: var(--__neon__text-color-light);\r\n    font: var(--__neon__font-1);\r\n    margin: var(--__neon__spacing-0);\r\n}\r\n\r\n.__mfe__settings_continious_date{\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n.__mfe__settings_continious_date_child{\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n.__mfe__settings-date-error{\r\n    box-sizing: border-box;\r\n    color: #e21707;\r\n    font: 400 14px / 20px Roboto, Arial, Helvetica, sans-serif;\r\n    margin: 2px 0 0;\r\n    padding: 0;\r\n    text-wrap: pretty;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
